<div class="row">
    <div class="col-lg-6 col-xl-4">
        <div class="card card-box card-shadow-first p-4 mb-5">
            <div class="d-flex justify-content-between mb-4">
                <div class="d-40 rounded-sm bg-neutral-first text-first text-center font-size-lg">
                    <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                </div>
                <div class="font-size-lg line-height-sm text-second text-right">
                    <div class="font-weight-bold">
                        $3,485
                    </div>
                    <small class="opacity-5">Sales</small>
                </div>
            </div>
            <div>
                <div class="d-flex mb-1 font-weight-bold justify-content-between font-size-sm">
                    <div class="text-uppercase opacity-6">
                        Target
                    </div>
                    <div>
                        17%
                    </div>
                </div>
                <progressbar [animate]="true" [value]="17" class="progress-sm" type="first"></progressbar>
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex justify-content-between mb-4">
                <div class="d-40 rounded-sm bg-neutral-success text-success text-center font-size-lg">
                    <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
                </div>
                <div class="font-size-lg line-height-sm text-second text-right">
                    <div class="font-weight-bold">
                        436
                    </div>
                    <small class="opacity-5">Reports</small>
                </div>
            </div>
            <div>
                <div class="d-flex mb-1 font-weight-bold justify-content-between font-size-sm">
                    <div class="text-uppercase opacity-6">
                        Target
                    </div>
                    <div>
                        44%
                    </div>
                </div>
                <progressbar [animate]="true" [value]="44" class="progress-sm" type="success"></progressbar>
            </div>
        </div>
    </div>
    <div class="col-lg-12 col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex justify-content-between mb-4">
                <div class="d-40 rounded-sm bg-neutral-danger text-danger text-center font-size-lg">
                    <fa-icon [icon]="['far', 'user']"></fa-icon>
                </div>
                <div class="font-size-lg line-height-sm text-second text-right">
                    <div class="font-weight-bold">
                        4867
                    </div>
                    <small class="opacity-5">Visitors</small>
                </div>
            </div>
            <div>
                <div class="d-flex mb-1 font-weight-bold justify-content-between font-size-sm">
                    <div class="text-uppercase opacity-6">
                        Target
                    </div>
                    <div>
                        65%
                    </div>
                </div>
                <progressbar [animate]="true" [value]="65" class="progress-sm" type="danger"></progressbar>
            </div>
        </div>
    </div>
</div>
